import {
  MemberFilter,
  MemberSort,
  QueryMembersForBulletinQuery,
  QueryMembersForBulletinQueryVariables,
} from '__generated__/graphql';
import gql from 'graphql-tag';
import { useLazyLoading } from 'hooks';
import useGraphQLClient from 'hooks/graphql/useGraphQLClient/useGraphQLClient';
import { useCallback } from 'react';
import { Nullable } from 'types/util/Nullable';

export const useMembersLazyLoading = (
  scroller: Nullable<HTMLElement>,
  filterInput?: MemberFilter,
  filterSort?: [MemberSort]
) => {
  const client = useGraphQLClient();
  const getMemberForBulletin = useCallback(
    async (after: Nullable<string>, first: number) => {
      const result = await client.request<QueryMembersForBulletinQuery, QueryMembersForBulletinQueryVariables>({
        document: MEMBERS_FOR_BULLETIN_QUERY,
        variables: {
          after,
          first,
          filter: filterInput,
          sort: filterSort,
        },
      });

      return result.members ?? [];
    },
    [client, filterInput, filterSort]
  );

  return useLazyLoading(scroller, getMemberForBulletin);
};

export const MEMBERS_FOR_BULLETIN_QUERY = gql`
  query QueryMembersForBulletin(
    $filter: MemberFilter
    $sort: [MemberSort!]
    $first: Int
    $pageNumber: Int
    $after: String
  ) {
    members(filter: $filter, sort: $sort, first: $first, pageNumber: $pageNumber, after: $after) {
      id
      firstName
      lastName
      imageUrl
      cursor
      archivedOn
    }
  }
`;
